const BUILD_NUMBER = "$BUILD_NUMBER"
const JOB_NAME = "$JOB_NAME"

const origin = window.location.origin;

export const JENKINSSNIPPETFORSCRIPT = `node {
    withCredentials([string(credentialsId: 'ARMORCODE_TOKEN', variable: 'TOKEN')]){
        sh '''
        i=0
        end=30
        while [ $i -lt $end ]
        do
            i=$(( $i + 1 ))
            curl --location --request POST '${origin}/client/buildvalidation' --header 'Content-Type: application/json' --header "Authorization: Bearer $TOKEN"  -d '{ "env": "{envName}", "product": "{product}", {subProduct}, "additionalAQLFilters": {additionalAQLFilters}, "buildNumber": "'"${BUILD_NUMBER}"'", "jobName":"'"${JOB_NAME}"'","current":"'$i'" , "end":"'$end'"}' > result.json
            status=$(jq -r '.status' result.json)
            if [ $status = "HOLD" ]
            then
                echo "Armorcode SLA failed."
                sleep 10
                echo "Sleeping 10 seconds before trying again. You can temporarily release the build from Armorcode console"
            elif [ $status = "FAILED" ]
            then
                echo "Exiting with error code 1"
                exit 1
            else
                break
            fi
        done
        '''
    }
}`

export const JENKINSSNIPPETFORPLUGIN = `pipeline {
    agent any
    stages {
        stage('Build') {
            steps {
                script {
                    armorcodeReleaseGate(product: "{product}", {subProduct}, env: "{envName}", mode: "{mode}")
                }
            }
        }
    }
}`

export const AZURESNIPPET = `- task: Bash@3
  inputs:
   targetType: 'inline'
   script: |
    i=0
    end=30
        while [ $i -lt $end ]
        do
            i=$(( $i + 1 ))
            curl --location --request POST '${origin}/client/buildvalidation' --header 'Content-Type: application/json' --header 'Authorization: Bearer $(ARMORCODE_TOKEN)'  -d '{ "env": "{envName}", "product": "{product}", "subProduct": "{subProduct}", "buildTool":"AZURE_PIPELINE", "buildNumber": "$(Build.BuildId)","current":"'$i'" , "end":"'$end'"}' > result.json
            status=$(jq -r '.status' result.json)
            if [ $status = "HOLD" ]
            then
                echo "Armorcode SLA failed."
                sleep 10
                echo "Sleeping 10 seconds before trying again. You can temporarily release the build from Armorcode console"
            elif [ $status = "FAILED" ]
            then
                echo "Exiting with error code 1"
                exit 1
            else
                break
            fi           
        done`

export const BAMBOOSNIPPET = `i=0
end=30
while [ $i -lt $end ]
do
    curl --location --request POST '${origin}/client/buildvalidation' --header 'Content-Type: application/json' --header 'Authorization: Bearer <YOUR TOKEN HERE>'  -d '{ "env": "{envName}", "product": "{product}", "subProduct": "{subProduct}", "buildTool":"BAMBOO", "buildNumber": "$\{bamboo.buildNumber}","current":"'$i'" , "end":"'$end'"}'  > result.json
    status=$(grep -o '"status":"[^"]*' result.json  | grep -o '[^"]*$')
            if [ $status = "HOLD" ]
            then
                echo "Armorcode SLA failed."
                sleep 10
                echo "Sleeping 10 seconds before trying again. You can temporarily release the build from Armorcode console"
            elif [ $status = "FAILED" ]
            then
                echo "Exiting with error code 1"
                exit 1
            else
                break
            fi          
done`


export const DRONESNIPPET = `kind: pipeline
type: docker
name: default
# copy below lines in your .drone.yml file 
environment:
  armorcodehost: ${origin}
  product: {product}
  subProduct: {subProduct}
  environment: {envName}
  token: <Your Token Here>
  buildTool: DRONE
  buildNumber: "$\{DRONE_BUILD_NUMBER}"
  end: 30
steps:
- name: ArmorCode Validation
  image: byrnedo/alpine-curl
  commands:
  - wget ${origin}/static/scripts/slastatus.sh
  - sh slastatus.sh
`

export const CIRCLECISNIPPET = `version: 2.1
jobs:
  armorcode-validate:
    docker:
      - image: byrnedo/alpine-curl
    environment:
      armorcodehost: ${origin}
      product: {product}
      subProduct: {subProduct}
      environment: {envName}
      token: $ARMORCODE_TOKEN
      buildTool: CIRCLE_CI
      buildNumber: "<< pipeline.number >>"
      end: 30
    steps:
      - run:
          name: "Armorcode Validate"
          command: |
              token=$ARMORCODE_TOKEN
              wget ${origin}/static/scripts/slastatus.sh
              sh slastatus.sh
workflows:
  armorcode-validation-workflow:
    jobs:
      - armorcode-validate
`

export const TEAMCITYSNIPPET = `i=0
while [ $i -lt 30 ]
do
  curl --location --request POST '${origin}/client/buildvalidation' --header 'Content-Type: application/json' --header 'Authorization: Bearer %system.ARMORCODE_TOKEN%'  -d '{ "env": "{envName}", "product": "{product}", "subProduct": "{subProduct}", "buildNumber": "'"$BUILD_NUMBER"'", "buildTool":"TEAM_CITY"}' > result.json
  status=$(grep -o '"status":"[^"]*' result.json  | grep -o '[^"]*$')
  if [ "$status" = "HOLD" ]
    then
    echo "Armorcode SLA failed."
    if [ $i = 30 ]
    then
        echo "Exiting with error code 1"
        exit 1
    fi
    echo "Sleeping 10 seconds before trying again. You can temporarily release the build from Armorcode console"
    sleep 10
    i=$(( $i + 1 ))
    else
    break
    fi
done
echo "SLA met at Armorcode"`

export const RELEASEIQSNIPPET = `#!/bin/bash
#Checking SLA in a loop for 30 times with interval of 10 seconds if the build status is on HOLD. This allows release engineering team to approve the build temporarily.

i=0
buildNumber=$(date +%s)
echo "BuildId : $buildNumber"
while [ $i -lt 31 ]
do
curl --location --request POST '${origin}/client/buildvalidation' --header 'Content-Type: application/json' --header 'Authorization: Bearer <YOUR TOKEN>'  -d '{ "env": "{envName}", "product": "{product}", "subProduct": "{subProduct}", "buildTool":"RELEASE_IQ", "buildNumber": "'"$buildNumber"'"}'  > result.json    
status=$(grep -o '"status":"[^"]*' result.json  | grep -o '[^"]*$')
    if [ "$status" = "HOLD" ]
    then
        echo "Armorcode SLA failed, tries : $i."
        if [ $i = 30 ]
        then
            echo "Exiting with error code 1"
            exit 1
        fi
        echo "Sleeping 10 seconds before trying again. You can temporarily release the build from Armorcode console"
        sleep 10
        i=$(( $i + 1 ))
    else
        break
    fi
done
echo "SLA met at Armorcode"`

export const BUILDKITESNIPPET = `
env:
  armorcodehost: ${origin}
  product: {product}
  subProduct: {subProduct}
  environment: {envName}
  token: <YOUR TOKEN HERE>
  buildTool: BUILDKITE
  end: 30
  
steps:
- label: "ArmorCode Validation"
  commands: 
    - "export buildNumber=$$BUILDKITE_BUILD_NUMBER"
    - "wget ${origin}/static/scripts/slastatus.sh"
    - "sh slastatus.sh"`


export const GITHUBACTIONSSNIPPET = `name: ArmorCode

env:
  armorcodehost: ${origin}
  product: {product}
  subProduct: {subProduct}
  environment: {envName}
  token: $\{{secrets.ARMORCODE_TOKEN}}
  buildTool: GITHUB_ACTIONS
  buildNumber: $\{{github.run_number}}
  end: 30
  
on:
  # Triggers the workflow on push request events
  push:
  # Allows you to run this workflow manually from the Actions tab
  workflow_dispatch:
  
jobs:
  build:
    runs-on: ubuntu-latest
    # ArmorCode Validation Step
    steps:
      - name: ArmorCode Validation
        run: |
          wget ${origin}/static/scripts/slastatus.sh
          sh slastatus.sh`

export const GITHUBACTIONSARMORCODESNIPPET = 
`name: ArmorCode Release Gate
on:
  push:
  pull_request:
  workflow_dispatch:
  
jobs:
  release_gate_check: # Update the job name as needed
    runs-on: ubuntu-latest
    permissions:
      checks: write     # For writing to the checks tab
      pull-requests: write  # For commenting on PRs
      contents: read    # For accessing repo content
    steps:  
      - name: Run ArmorCode Release Gate
        id: armorcode_gate
        uses: ${origin === 'https://qa.armorcode.ai' ? 'docker://public.ecr.aws/r4h5z0d3/armorcode-release-gate:latest' : 'docker://public.ecr.aws/armor-code/armorcode-release-gate:latest'}
        with:
          product: '{product}'
          subProduct: '{subProduct}'
          env: '{envName}'
          armorcodeHost: '${origin}'
          mode: '{mode}'
          armorcodeAPIToken: \${{ secrets.ARMORCODE_API_TOKEN }}
          githubToken: \${{ github.token }}
          additionalAQLFilters: "{additionalAQLFilters}"`
    


export const GITLABCISNIPPET = `image: alpine/curl

ArmorCode Validation:
  stage: test
  variables:
    armorcodehost: ${origin}
    product: {product}
    subProduct: {subProduct}
    environment: {envName}
    token: "$ARMORCODE_TOKEN"
    buildTool: GITLAB_CI
    buildNumber: "$CI_PIPELINE_IID"
    end: 30
  script:
    - wget ${origin}/static/scripts/slastatus.sh
    - sh slastatus.sh`